var map = {
	"./beach-off.png": 162,
	"./beach.png": 163,
	"./default-off.png": 164,
	"./default.png": 165,
	"./desert-card-off.png": 166,
	"./desert-card.png": 167,
	"./desert-crossroads-disabled.png": 168,
	"./desert-crossroads-off.png": 169,
	"./desert-crossroads.png": 170,
	"./desert-energy-off.png": 171,
	"./desert-energy.png": 172,
	"./desert-hidden-off.png": 173,
	"./desert-hidden.png": 174,
	"./desert-large-arena-off.png": 175,
	"./desert-large-arena.png": 176,
	"./desert-large-disabled.png": 177,
	"./desert-large-locked-disabled.png": 178,
	"./desert-large-locked.png": 179,
	"./desert-large-off.png": 180,
	"./desert-large.png": 181,
	"./desert-life-off.png": 182,
	"./desert-life.png": 183,
	"./desert-locked-disabled.png": 184,
	"./desert-locked.png": 185,
	"./desert-off.png": 186,
	"./desert-save-off.png": 187,
	"./desert-save.png": 188,
	"./desert-time-off.png": 189,
	"./desert-time.png": 190,
	"./desert.png": 191,
	"./forest-crossroads-off.png": 192,
	"./forest-crossroads.png": 193,
	"./forest-exclamation-disabled.png": 194,
	"./forest-exclamation.png": 195,
	"./forest-large-arena.png": 196,
	"./forest-large.png": 197,
	"./forest-locked.png": 198,
	"./forest-off.png": 199,
	"./forest-question-disabled.png": 200,
	"./forest-question.png": 201,
	"./forest-tyrannosaure-off.png": 202,
	"./forest-tyrannosaure.png": 203,
	"./forest.png": 204,
	"./jungle-big-off.png": 205,
	"./jungle-big.png": 206,
	"./jungle-crossroad-off.png": 207,
	"./jungle-crossroad.png": 208,
	"./jungle-exclamation-off.png": 209,
	"./jungle-exclamation.png": 210,
	"./jungle-fight-off.png": 211,
	"./jungle-fight.png": 212,
	"./jungle-gift-off.png": 213,
	"./jungle-gift.png": 214,
	"./jungle-leave-off.png": 215,
	"./jungle-leave.png": 216,
	"./jungle-leave2-off.png": 217,
	"./jungle-leave2.png": 218,
	"./jungle-leave3-off.png": 219,
	"./jungle-leave3.png": 220,
	"./jungle-leave4-off.png": 221,
	"./jungle-leave4.png": 222,
	"./jungle-leave5-off.png": 223,
	"./jungle-leave5.png": 224,
	"./jungle-off.png": 225,
	"./jungle-question-off.png": 226,
	"./jungle-question.png": 227,
	"./jungle-search-off.png": 228,
	"./jungle-search.png": 229,
	"./jungle-trex-off.png": 230,
	"./jungle-trex.png": 231,
	"./jungle.png": 232,
	"./level-done-one-star.png": 233,
	"./level-done-three-stars.png": 234,
	"./level-done-two-stars.png": 235,
	"./level-special-off.png": 236,
	"./level-special.png": 237
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 161;